import * as React from 'react';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetTranslations } from '@/generated/translations';
import { ArrowButton, ArrowButtonProps } from './ArrowButton';

export const ArrowButtonWithOverrides: React.FC<ArrowButtonProps> = (props) => {
	const { segmentationId } = React.useContext(SegmentationContext);
	const { data: translations } = useGetTranslations(segmentationId);

	return (
		<ArrowButton
			{...props}
			prevLabel={translations?.data.shared.previous}
			nextLabel={translations?.data.shared.next}
		/>
	);
};
